import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  G2_P1_S1_Title: {
    id: `guide02.page01.slide01.title`,
  },
  G2_P1_S1_Description: {
    id: `guide02.page01.slide01.description`,
  },
});
